import axios from "axios";
import actions from "./actions";

const fetchBenchmarks = (options) => (dispatch, getState) => {
  dispatch(actions.fetchBenchmarksStart());
  const { token, workSettingBenchmarks } = options;
  function retryOnFail(task, attempt) {
    if (!attempt) {
      attempt = 1;
    }
    return task().catch((err) => {
      if (attempt < 3) {
        attempt += 1;
        return retryOnFail(task, attempt);
      } else {
        dispatch(actions.fetchBenchmarksError(err));
      }
    });
  }
  function getResource(url) {
    return retryOnFail(function () {
      return axios.get(url);
    });
  }
  getResource(`/api/benchmarks/${workSettingBenchmarks}?token=${token}`).then((res) => {
    const benchmarks = {};
    res.data.forEach(benchmark => {
      benchmarks[benchmark.name] = {};
      benchmark.percentiles.forEach(percentile => benchmarks[benchmark.name][percentile.domain] = percentile.percentage);
    });
    dispatch(actions.fetchBenchmarks(benchmarks));
  });
};

const clear = () => (dispatch, getState) => {
  dispatch(actions.clear());
};

const applyBenchmark = (benchmark) => (dispatch, getState) => {
  dispatch(actions.applyBenchmark(benchmark))
}

export default {
  fetchBenchmarks,
  clear,
  applyBenchmark
};



// WEBPACK FOOTER //
// ./src/redux/benchmarks/operations.js